export default __webpack_public_path__ + "static/blob14-ee7b25c1e29f09044ac7e96523a19a4e.svg";